import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  bgcolor: 'grey.100',
  borderRadius: 0.5,
  p: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const row: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.25,
};
